// extracted by mini-css-extract-plugin
module.exports = {"icon":"_3NY2Ef84II3-95rsMA5oSt"};